<template>
  <div>
    <!-- <Sidebar /> -->
    <Header :headerType="5"></Header>
    <!-- <company-menu/> -->
    <main class="">
      <slot></slot>
    </main>
    <Footer :footerType="2" />
  </div>
</template>

<script>
import sessionMixin from '../mixins/sessionMixin.js'
import Header from "../components/Header.vue";
// import Sidebar from "../components/Sidebar.vue";
import Footer from "../components/Footer.vue";

// import CompanyMenu from "../components/CompanyMenu.vue";

export default {
  mixins: [sessionMixin],
  components: {
    Header,
    // Sidebar,
    Footer,
    // CompanyMenu,
  },
  data() {
    return {};
  },
  mounted() {
    console.log('AQUI EMPLOYEE')
  },
  methods: {},
};
</script>

<style lang="scss">
@import "../scss/reset.scss";
@import "../scss/base.scss";
@import "../scss/form.scss";
@import "../css/mobile.css";


.container-fluid-mobile {
  padding: 0px;
  /* background-color: #fff; */
}

.mx-btn-text{
		width: auto !important;
	}

.company-page{
  padding-top:  50px;
  padding-bottom:  50px;
}

@media only screen and (max-width: 600px) {
  main {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}
</style>
